import {gql} from 'graphql-request';

const GET_PRODUCT_LIST_FACETS_BY_SLUG_QUERY = gql`
  query getProductListFacets(
    $slug: String
    $sort: ProductsQuerySortParameter
    $filter: ProductFilterParameter
    $facets: [String]
  ) {
    productList(slug: $slug, sort: $sort, filter: $filter, facets: $facets) {
      facets {
        key
        label
        options {
          label
          position
          resultCount
          swatch {
            type
            value
          }
          value
        }
      }
    }
  }
`;

export default GET_PRODUCT_LIST_FACETS_BY_SLUG_QUERY;
